// extracted by mini-css-extract-plugin
export var progressBar = "_jk-0";
export var progressBarInner = "_jk-1";